import { Trans, useTranslation } from 'react-i18next'

import { ConfirmationModal, Modal, Text } from '@percent/lemonade'

type GoogleCalendarPreIntegrationModalProps = {
  openModal: boolean
  handleClose: VoidFunction
  handleSubmit: VoidFunction
}

export function GoogleCalendarPreIntegrationModal({
  openModal,
  handleClose,
  handleSubmit
}: Readonly<GoogleCalendarPreIntegrationModalProps>) {
  const { t } = useTranslation()

  return (
    <Modal borderRadiiSize="xlarge" onClose={handleClose} open={openModal}>
      <ConfirmationModal
        buttonShape="oval"
        title={t('workplace_giving.settings.calendarIntegration.instructionModal.title')}
        primaryButtonText={t('workplace_giving.settings.calendarIntegration.instructionModal.continueBtn')}
        secondaryButtonText={t('workplace_giving.common.cancel')}
        handleClose={handleClose}
        handleSubmit={handleSubmit}
      >
        <Text size="small">
          <Trans
            t={t}
            i18nKey="workplace_giving.settings.calendarIntegration.instructionModal.description"
            components={[<span style={{ fontWeight: 500 }} />]}
          />
        </Text>
      </ConfirmationModal>
    </Modal>
  )
}
